import React from 'react';
import SMClickOutsideObserver from 'lib/SMClickOutsideObserver';

class SMBaloonBaseView extends React.Component {
  
  constructor(props) {
    super(props);
    this.isMouseOver = false;
  }
  
  componentDidMount(){
    this.clickOutsideObserver = new SMClickOutsideObserver(this);
    this.clickOutsideObserver.attach(()=>{});
    let offset = this.props.originFrame.offset,
        size = this.props.originFrame.size,
        $baloon = $(this.refs.baloon),
        windowWidth = $(window).width(),
        windowHeight = $(window).height();
        
    if (offset.left + $baloon.width() > windowWidth) {
      offset.left -= $baloon.width() - size.width;
    }
    offset.top += size.height + 12;
    
    $baloon.offset(offset);
  }
  
  componentWillUnmount() {
    this.clickOutsideObserver.detach();
  }
  
  onMouseEnter(e){
    this.isMouseOver = true;
  }
  
  onMouseLeave(e){
    $(document).trigger("SMHideBaloon");
  }
}
export default SMBaloonBaseView;



// WEBPACK FOOTER //
// ./app/javascript/components/shared/SMBaloonBaseView.jsx